/**
 * Centralised TanStack query keys for the Configuration domain.
 *
 * The full configuration structure is loaded via Inertia and stored under
 * the root key by `useConfigurationQuery`. Mutations Inertia-reload the
 * page to refresh the resolved values.
 */
export const CONFIGURATION_QUERY_KEY = ['configuration'] as const

// Structure resolved at a non-tenant scope (e.g. a location) — cached apart from the
// root key so tenant-scope readers never see another scope's resolved values.
export const configurationScopedQueryKey = (scope: { type: string; id: string }) =>
  [...CONFIGURATION_QUERY_KEY, 'scoped', scope.type, scope.id] as const

export const CONFIGURATION_TRACE_QUERY_KEY = ['configuration', 'trace'] as const

export const configurationTraceQueryKey = (key: string, scope: { type?: string; id?: string | null } | null) =>
  [...CONFIGURATION_TRACE_QUERY_KEY, key, scope?.type ?? null, scope?.id ?? null] as const

// Prefix for invalidating every cached trace for a given key across all scopes
// — a write at one scope can change the resolved value at another (e.g. a
// tenant override now wins for a location that previously had no override).
export const configurationTraceQueryKeyForKey = (key: string) => [...CONFIGURATION_TRACE_QUERY_KEY, key] as const
